{
  "commonHeader": {
    "toggleSidebar": "Tampilkan atau sembunyikan bilah sisi",
    "cartLoading": "Keranjang belanja sedang dimuat",
    "cart": "Keranjang belanja",
    "aicForAdmin": {
      "ariaLabel": "AI untuk admin"
    },
    "usersResults": "Pengguna, {0} hasil",
    "settingsResults": "Pengaturan, {0} hasil",
    "navigationResults": "Navigasi, {0} hasil",
    "learnMoreAbout": "Pelajari selengkapnya tentang {0}",
    "close": "Tutup",
    "products": "Produk",
    "moreActions": "Tindakan lainnya",
    "search": "Cari",
    "searchPlaceholderAll": "Cari pengguna, pengaturan akun, atau navigasi",
    "searchPlaceholderUsers": "Cari pengguna atau navigasi",
    "searchPlaceholderSettings": "Cari pengaturan akun atau navigasi",
    "searchPlaceholderNav": "Cari navigasi"
  },
  "footerCopyright": {
    "language": "Bahasa {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Menu admin"
    }
  },
  "shared": {
    "close": "Tutup",
    "sideMenu": {
      "personalAria": "Menu pribadi",
      "adminAria": "Menu admin",
      "mainNav": "Navigasi utama",
      "submenu": "Submenu",
      "pinnedSection": "{0} disematkan",
      "sideMenuAria": "Menu samping",
      "pinItem": "Sematkan {0}",
      "unpinItem": "Lepaskan sematan {0}",
      "reorderGrabbed": "Mengurutkan ulang {0}, dipegang. Gunakan tombol panah atas dan bawah untuk memindahkan, spasi atau Enter untuk meletakkan, Escape untuk membatalkan.",
      "reorderIdle": "Urutkan ulang {0}. Tekan spasi atau Enter untuk memegang.",
      "hintHandlePin": "Tekan Tab untuk mengakses gagang seret dan tombol semat",
      "hintHandle": "Tekan Tab untuk mengakses gagang seret",
      "hintPin": "Tekan Tab untuk mengakses tombol semat",
      "upgradeToPro": "Tingkatkan ke Pro"
    },
    "item": "Item"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Coba pengalaman baru"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Tutup"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Divisi kini tersedia"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Kelola akun eksternal"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Buku Alamat akan menjadi Direktori Pelanggan"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Area Produk",
    "itemLableForFeedback": "Umpan Balik"
  }
}
